import { createAction, props } from '@ngrx/store';

import { type ChatMessagesResponse } from '@blaze-dashboard/ai-chat-domain';

export const startPollingChatMessages = createAction(
  '[AI Chat] Start polling chat messages',
  props<{ projectId: string; chatConversationId: string }>(),
);

export const chatMessagesPolled = createAction(
  '[AI Chat] Chat messages polled',
  props<{ chatMessagesResponse: ChatMessagesResponse }>(),
);

export const retryPollingChatMessages = createAction('[AI Chat] Retry polling chat messages');

export const chatMessagesPollingFailure = createAction(
  '[AI Chat] Chat messages polling failure',
  props<{ error: string }>(),
);
